export default "__VITE_ASSET__COv0fuFV__"